var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgImage = function SvgImage(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-picture-landscape-1--photos-photo-landscape-picture-photography-camera-pictures",
    clipPath: "url(#clip0_3103_7123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.15719 19.2852L17.8715 19.2852C18.6605 19.2852 19.3 18.6456 19.3 17.8566L19.3 2.1423C19.3 1.35332 18.6605 0.71373 17.8715 0.71373L2.15719 0.71373C1.36822 0.71373 0.728622 1.35332 0.728622 2.1423L0.728622 17.8566C0.728622 18.6456 1.36822 19.2852 2.15719 19.2852Z",
    stroke: "#1B2031",
    strokeOpacity: 0.74,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.2144 9.28516C14.5951 9.28516 15.7144 8.16587 15.7144 6.78516C15.7144 5.40444 14.5951 4.28516 13.2144 4.28516C11.8336 4.28516 10.7144 5.40444 10.7144 6.78516C10.7144 8.16587 11.8336 9.28516 13.2144 9.28516Z",
    stroke: "#1B2031",
    strokeOpacity: 0.74,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.4286 19.2851C12.9686 16.835 11.6531 14.6282 9.71683 13.0582C7.78052 11.4882 5.34939 10.6573 2.85721 10.7136C2.13818 10.7117 1.42061 10.7787 0.714355 10.9136",
    stroke: "#1B2031",
    strokeOpacity: 0.74,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.2858 14.157C18.1352 13.7685 16.9288 13.5706 15.7144 13.5713C14.1771 13.568 12.6555 13.8791 11.2429 14.4856",
    stroke: "#1B2031",
    strokeOpacity: 0.74,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3103_7123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image.64737d94e0eb5ef5d31d906510217ee5.svg";